import Beans3 from '@/beans';

const Auth = {
  _getIDs() {
    try {
      const { user, account } = Beans3._utils.getCookie('beans_cjs');
      return { account, id: user.id, email: user.email };
    } catch (error) {
      return { id: '', email: '' };
    }
  },
  _update(resolve, reject) {
    Beans3.get({ path: `ultimate/account/current` }).then(resolve).catch(reject);
  },
  authenticate() {
    const cjs = Auth._getIDs();
    Beans3._cache.set('auth-shopper-id', cjs.id);
    Beans3._cache.set('auth-shopper-email', cjs.email);
    Beans3.setAccountToken(cjs.account?.token);
    Beans3.setAccountID(cjs.account?.id);

    return new Promise(function (resolve, reject) {
      if (Beans3.getAccountID() && Beans3._session.get('tka')) {
        Auth._update(resolve, reject);
        return;
      }
      resolve(null);
    });
  },
  /**
   * This method is only used when the merchant has activated manually registration
   */
  onRegister() {
    if (document.body.classList.contains('logged-in')) {
      // Submit the form that confirm that the user wants to join the program
      const form = document.createElement('form');
      form.method = 'post';
      form.action = '';

      const input = document.createElement('input');
      input.value = 'manual-registration';
      input.name = 'beans_action';

      form.appendChild(input);
      document.body.appendChild(form);

      form.submit();
    } else {
      // Redirect the user to the login page
      window.location = window.beans_init_data.pages.register;
    }
  },
};

export default Auth;
